<template>
  <div class="voice-list">
    <van-nav-bar title="发送短消息" :fixed="true" style="margin-bottom:15px;" left-text="返回" :border="false" left-arrow @click-left="backPage" />
    <p class="voice-title">
      您可以给孩子发送一条或多条消息，孩子可点击设备对应按键接收短消息；下方列表最多展示最近15天的消息；
    </p>
    <div class="btn-bottom" v-if="voiceList.length>0">
      <div class="voice-box" v-for="(item,index) in voiceList" :key="index">
        <p class="list-date">{{item.createDate}}</p>
        <div class="list-content">
          <img class="list-img" src="@/assets/images/send_ed.png" background-size="cover" />
          <div class="list-text">
            {{item.message}} 
          </div>
        </div>
        <div :class="[item.readStatus==0?'readstatus-gray':'readstatus-blue']">
          {{item.readStatus==0?'未读':'已读'}}
        </div>
      </div>
    </div>
    <div v-else class="address-content">
      <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
      <p class="address-txt">暂无新的下发消息</p>
    </div>
    <div class="btn-box">
      <van-button round type="info" @click="addVoice">新增消息</van-button>
      <p v-if="needDelete" :class="['delete-time',voiceList.length<=0?'del-allowed':'del-check']" @click="deleteVoiceList">清空消息列表</p>
    </div>
    <van-dialog id="van-dialog" />
  </div>
</template>

<script>
export default {
  data () {
    return {
      needDelete:true,
      voiceList:[],
    }
  },
  created(){
    this.getVoiceList()
  },
  onLoad(){
  },
  methods: {
    /**
     * 返回上一级
     */
    backPage() {
      this.$router.back(-1);
    },
    //获取语音消息列表
    getVoiceList(){
      let data = {
        ver:1,
        method:'selectShortMessageList',
        instructionId:this.$intfilter.instructFilter('短消息'),
      }
      this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
          if (res.code === 0) {
            this.voiceList = res.data
          }else{
            this.$toast({
              message: res.msg,
              duration: 2000,
              icon: require('@/assets/images/safety-fence/wrong.png'),
            });
          }
      })
    },
    /**
    跳转去新增消息
     */
    addVoice(){
      this.$router.push({ name: 'addVoice' });
    },
    /**
    清空消息列表
     */
    deleteVoiceList(){
      // if(this.voiceList.length<=0){
      //   return
      // }
      this.$dialog.confirm({
        title: '提示',
        message: '确认是否清空列表信息？',
      })
        .then(() => {
          let data = {
            ver:1,
            method:'deleteShortMessageList',
            imei:this.imei
          }
          this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
              if (res.code === 0) {
                this.$toast({
                  message: "删除成功",
                  icon: "success"
                });
                this.getVoiceList()
              } else {
                this.$toast({
                  message: res.msg,
                  duration: 2000,
                  icon: require('@/assets/images/safety-fence/wrong.png'),
                });
              }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
  },

}
</script>

<style scoped>
.voice-list{
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 120px 30px 120px;
}
.voice-title{
  font-size: 28px;
  color: #999999;
}
.voice-box .list-date{
  font-size: 24px;
  text-align: center;
  margin: 20px 0;
  color: #999999;
}
.list-content{
  display: flex;
  align-items: center;
}
.list-img{
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.list-text{
  flex: 1;
  font-size: 28px;
  color: #666666;
  padding: 20px 24px;
  background-color: #fff;
  border-radius: 20px;
}
.address-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 300px;
  font-size: 28px;
  font-weight: 400;
  color: #999999;
}
.address-img{
  width: 426px;
  height: 230px;
}
.address-txt{
  margin-top: 50px;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
}
.btn-bottom{
  margin-bottom: 200px;
}
.btn-box .delete-time{
  margin-top: 48px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  border-bottom: 1px solid #ccc;
}
.readstatus-gray{
  margin: 5px 20px 0 0;
  font-size: 22px;
  text-align: right;
  color: #333;
  /* color: rgba(0, 0, 0, 0.35); */
}
.readstatus-blue{
  margin: 5px 20px 0 0;
  font-size: 22px;
  text-align: right;
  /* color: #01ADA9; */
  color: rgba(0, 0, 0, 0.35);
}
.del-allowed{
 color: #ccc;
}
.del-check{
 color: #666;
}
</style>
<style>
.voice-list .btn-box .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background: #01ADA9;
  color: #fff;
  border: 2px solid #01ADA9; 
}
</style>
